import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {Link} from "../../link/link";
import styles from "./list.module.scss";
import classNames from "classnames";

export class ListItemProps extends BaseProps {
  item: BaseViewModel;
  className: String;
  disableLink: Boolean = false;
}

export const ListItem = (props: ListItemProps) => {
  if(!props.item) {
    return null;
  }

  const onClick = () => {
    if (props.onChange) {
      props.onChange(props.item)
    }

    return true;
  };

  return (
    props.disableLink && props.item.linkModel ? <Link disable={props.disableLink} model={props.item.linkModel}
                                                      className={classNames(styles.item, props.className)}
                                                      onClick={onClick}>
      <bdi>{props.item.name}</bdi>
    </Link> : <bdi className={classNames(styles.item, props.className)} onClick={onClick}>{props.item.name}</bdi>
  )
}
